import { GET_USER_CART, ADD_SHOP, DEL_SHOP, REMOVE_ALL_SHOP, CALCULATE_PRICE,REQUEST_ERROR} from '../reducers/cartReducers/visibility';
import {isJSON} from '../utils/util';
import Api from "../utils/api";

// 获取用户购物车所有数据
export function getUserCartData(isOneSignIn) {
  return function(dispatch) {
    return Api.getCart().then(data => {
       dispatch(getCartDataSuccess(data,isOneSignIn));
      }).catch(error => {
        console.log(error)
      });
  };
}

// 往购物车中更新一件商品一条数据添加 or 删除 
export function addOrDeleteCartGoodsData(product,modeAction) {
  let cartGoodsList = localStorage.getItem('recommendations_cart_fetched_with_prod')?localStorage.getItem('recommendations_cart_fetched_with_prod'):[];
  if(cartGoodsList && isJSON(cartGoodsList)){
    cartGoodsList = JSON.parse(cartGoodsList)
  }
  return function(dispatch) {
    return Api.saveCartForLater(product,cartGoodsList,modeAction)
      .then(data => {

        if(data.actionType == "ADD"){
          dispatch(addShopSuccess(data.cartData));
        }else if(data.actionType == "DEL"){
          dispatch(deleteShopSuccess(data.cartData));
        }else if(data.actionType == "CLEARCART"){
          dispatch(deleteAllCartGoodsData());
        }else if(data.actionType =="ERROR"){
          dispatch(errorManager());
        }
      }).catch(error => {
        console.log(error)
      });
  };
}


// 清空购物车.把 state 中数据清空
export function deleteAllCartGoodsData() {
  return function(dispatch) {
    return Api.clearCart().then(data => {
          dispatch(deleteAllShopSuccess([]));
      }).catch(error => {
        console.log(error)
      });
  };
}

export function fun_deleteAllCartGoodsData() {
  return function(dispatch) {
    dispatch(deleteAllShopSuccess([]));
  };
}


function getCartDataSuccess(data,isOneSignIn) {
  return {
    type: GET_USER_CART,
    payload: data,
    isOneSignIn:isOneSignIn
  };
}

function addShopSuccess(data) {
  return {
    type: ADD_SHOP,
    payload: data
  };
}

function deleteShopSuccess(data) {
  return {
    type: DEL_SHOP,
    payload: data
  };
}

function deleteAllShopSuccess(data) {
  return {
    type: REMOVE_ALL_SHOP,
    payload: data
  };
}
function errorManager(){
  return {
    type: REQUEST_ERROR,
  };
}

// function calculate_all_Shop_price(data) {
//   return {
//     type: CALCULATE_PRICE,
//     payload: data
//   };
// }


// WEBPACK FOOTER //
// ./src/actions/cartAction.js